/* eslint-disable jira/filename-case */
export const DATA_MANAGER_ADMIN = 'ari:cloud:cmdb::role/airtrack/admin' as const;
export const DATA_MANAGER_REPORT_VIEWER = 'ari:cloud:cmdb::role/airtrack/report-viewer' as const;
export const DATA_MANAGER_REPORT_EDITOR = 'ari:cloud:cmdb::role/airtrack/report-editor' as const;
export const DATA_MANAGER_ADAPTERS_ADMIN = 'ari:cloud:cmdb::role/airtrack-buoy/admin' as const;

export const DATA_MANAGER_ROLES: string[] = [
	DATA_MANAGER_ADMIN,
	DATA_MANAGER_REPORT_VIEWER,
	DATA_MANAGER_REPORT_EDITOR,
];

export const DATA_MANAGER_ADAPTERS_ROLES: string[] = [DATA_MANAGER_ADAPTERS_ADMIN];

export const ORDERED_ASSETS_DATA_MANAGER_ROLES: (
	| 'ari:cloud:cmdb::role/airtrack/admin'
	| 'ari:cloud:cmdb::role/airtrack/report-viewer'
	| 'ari:cloud:cmdb::role/airtrack/report-editor'
	| 'ari:cloud:cmdb::role/airtrack-buoy/admin'
)[] = [
	DATA_MANAGER_ADMIN,
	DATA_MANAGER_ADAPTERS_ADMIN,
	DATA_MANAGER_REPORT_EDITOR,
	DATA_MANAGER_REPORT_VIEWER,
];

export const DATA_MANAGER_CLASS_SETTING_ROUTE_NAME = 'assets-data-manager-object-class-settings';

export const DATA_MANAGER_OPEN_ROUTE_ALL_ROLES: string[] = [
	'assets-data-manager-getting-started',
	'assets-data-manager-object-classes',
	'assets-data-manager-object-class-view',
	'assets-data-manager-data-source',
	'assets-data-manager-object-detail-view',
	DATA_MANAGER_CLASS_SETTING_ROUTE_NAME,
];
